import { isAsocoinsFeatureEnabled } from "./featureFlags";

const DEVELOPMENT_ENVIRONMENT = "development";
const MEMBER_ROLES = ["MEMBER", "MEMBERSHIP_USER"];
const ORGANIZATION_ROLES = ["ORGANIZATION", "HEAD_OFFICE", "ONE_LEVEL_HEAD_OFFICE"];
export const ASOFOM_ORGANIZATION_ID = "696fe6b02268d27aba1d58e6";

export const PRODUCT_SERVICES_ORGANIZATION_IDS = [
  "696fe6b02268d27aba1d58e6", // ASOFOM
  "6500e21c80d167001bf44b63", // Canaco León
];

export const isDevelopmentEnvironment = () =>
  process.env.VUE_APP_ENVIRONMENT === DEVELOPMENT_ENVIRONMENT;

const getId = (value) => {
  if (!value) return null;
  if (typeof value === "object") return value._id || value.id || null;
  return value;
};

const hasPermissionFlag = (user, subject, action) => {
  const permissions = user?.permissions;
  if (Array.isArray(permissions)) {
    return permissions.some((permission) =>
      permission?.subject === subject && permission[action] === true,
    );
  }

  const permission = permissions?.[subject];
  return Boolean(
    permission &&
      typeof permission === "object" &&
      permission[action] === true,
  );
};

export const resolveSofomId = (user) => {
  if (!user) return null;
  if (user.role === "MEMBER") return getId(user._id);
  if (user.role === "MEMBERSHIP_USER") return getId(user.membership);
  return null;
};

const resolveOrganizationId = (user) => {
  if (!user) return null;
  if (MEMBER_ROLES.includes(user.role)) {
    return getId(user.headOffice);
  }
  if (user.role === "ORGANIZATION_USER") {
    return getId(user.organization || user.headOffice);
  }
  if (ORGANIZATION_ROLES.includes(user.role)) {
    return getId(user._id);
  }
  return null;
};

export const getSpecialOrganizationPermission = (user) => {
  if (
    user?.role !== "ORGANIZATION_USER" ||
    resolveOrganizationId(user) !== ASOFOM_ORGANIZATION_ID ||
    !hasPermissionFlag(user, "ASOCOINS", "read") ||
    !hasPermissionFlag(user, "ASOCOINS", "update")
  ) {
    return null;
  }

  return hasPermissionFlag(user, "COMMUNITY", "read")
    ? "COMMITTEE_MANAGER"
    : "ASOCOINS_ONLY";
};

const getUserOrganizationIds = (user) => {
  if (!user) return [];

  return [
    getId(user._id),
    getId(user.organization),
    getId(user.headOffice),
  ].filter(Boolean);
};

export const canAccessProductServices = (user) =>
  isDevelopmentEnvironment() ||
  getUserOrganizationIds(user).some((id) =>
    PRODUCT_SERVICES_ORGANIZATION_IDS.includes(id)
  );

export const canAccessVoting = (user) =>
  getUserOrganizationIds(user).includes(ASOFOM_ORGANIZATION_ID);

export const canAccessAsocoins = (user) =>
  isAsocoinsFeatureEnabled() &&
  resolveOrganizationId(user) === ASOFOM_ORGANIZATION_ID &&
  (ORGANIZATION_ROLES.includes(user?.role) ||
    (MEMBER_ROLES.includes(user?.role) && Boolean(resolveSofomId(user))) ||
    (user?.role === "ORGANIZATION_USER" && hasPermissionFlag(user, "ASOCOINS", "read")));

export const canManageAsocoins = (user) =>
  canAccessAsocoins(user) &&
  (ORGANIZATION_ROLES.includes(user?.role) ||
    (user?.role === "ORGANIZATION_USER" && hasPermissionFlag(user, "ASOCOINS", "update")));
